import { Link } from "react-router-dom"

export type NavAnimatedLinkTone = "hero" | "solid"

export type NavAnimatedLinkProps = {
  to: string
  label: string
  isActive?: boolean
  tone?: NavAnimatedLinkTone
  className?: string
}

export const NavAnimatedLink = ({
  to,
  label,
  isActive = false,
  tone = "solid",
  className = "",
}: NavAnimatedLinkProps) => {
  const chars = Array.from(label)

  return (
    <Link
      to={to}
      className={`nav-menu-link nav-link-animate ${
        tone === "hero" ? "nav-link-animate-hero" : "nav-link-animate-solid"
      } ${isActive ? "nav-link-animate-active" : ""} ${className}`}
      aria-current={isActive ? "page" : undefined}
    >
      <span className="nav-link-animate-glow" aria-hidden />
      <span className="nav-link-animate-chars">
        {chars.map((char, index) => (
          <span
            key={`${char}-${index}`}
            className="nav-link-animate-char-wrap"
            style={{ ["--char-index" as string]: index }}
          >
            <span className="nav-link-animate-char-track" aria-hidden={false}>
              <span className="nav-link-animate-char">{char === " " ? "\u00A0" : char}</span>
              <span className="nav-link-animate-char" aria-hidden>
                {char === " " ? "\u00A0" : char}
              </span>
            </span>
          </span>
        ))}
      </span>
    </Link>
  )
}
